<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    service: { type: Object, required: true },
    duration: { type: Number, required: true },
  },

  emits: ['update:form-submit', 'update:service'],

  data() {
    return {
      mileages: {},
      table: {},
      mileage: 0,
      pack: null,
      packBold: null,
      durations: [],
      idArgus: null,
      isOfferAvailable: true,
    }
  },

  methods: {
    selectMileage(mile) {
      if (!mile) mile = 0
      this.mileage = mile

      this.$emit('update:service', { 'others.mileage': mile })

      if (mile > 0 && this.mileages) {
        this.durations = this.getDurations(this.table)
      } else {
        this.durations = []
      }
      this.setIsOfferAvailable()
    },
    selectPack(p) {
      this.packBold = p
      this.pack = p

      this.$emit('update:service', { 'others.pack': this.pack })
      this.setIsOfferAvailable()
    },
    getPrice(pack, duration) {
      if (this.table[this.mileage] && this.table[this.mileage][pack] && this.table[this.mileage][pack][duration]) {
        return this.$root.$n(Number(this.table[this.mileage][pack][duration].priceexclVAT), 'currency')
      }
      return ''
    },
    getDurations(table) {
      let durations = this.durations
      if (!this.mileage) {
        return durations
      }
      for (const [pack, dur] of Object.entries(table[this.mileage])) {
        durations = durations.concat(Object.keys(dur))
      }
      durations.sort()
      const isFirstOccurrence = (value, index, self) => self.indexOf(value) === index
      return durations.filter(isFirstOccurrence)
    },
    getIsOfferAvailable() {
      const selectedDurations = Object.keys(this.table[this.mileage][this.pack])
      return selectedDurations.includes(`${this.duration}`)
    },
    setIsOfferAvailable() {
      const isOfferAvailable = this.getIsOfferAvailable()
      if (isOfferAvailable !== this.isOfferAvailable) {
        this.isOfferAvailable = isOfferAvailable
        this.$emit('update:form-submit', { disabled: !isOfferAvailable })
      }
    },
    getTable(value) {
      const datas = this.parseOthersApiValue(value).datas
      if (!datas) {
        return null
      }
      // Order pack entries as ESSENTIEL, CONFORT, PREMIUM
      function compare(a, b) {
        if (a === 'ESSENTIEL') {
          return b === 'ESSENTIEL' ? 0 : -1
        }
        if (a === 'PREMIUM') {
          return b === 'PREMIUM' ? 0 : 1
        }
        return b === 'ESSENTIEL' ? 1 : -1
      }
      return Object.entries(datas)
        .map(([mileage, packs]) => [
          mileage,
          Object.keys(packs)
            .sort(compare)
            .reduce((obj, key) => ({ ...obj, [key]: packs[key] }), {}),
        ])
        .reduce((obj, [mileage, packs]) => ({ ...obj, [mileage]: packs }), {})
    },
    parseOthersApiValue(value) {
      return typeof value === 'string' ? JSON.parse(value) : value
    },
  },

  watch: {
    service: {
      deep: true,
      handler(val) {
        this.table = this.getTable(val.others.api.value)
        if (this.table && Object.keys(this.table).length > 0) {
          this.mileages = Object.keys(this.table)

          this.mileage = this.mileages[0]
          this.durations = this.getDurations(this.table)
          this.pack = Object.keys(this.table[this.mileage])[0]
          this.$emit('update:service', { 'others.mileage': this.mileage, 'others.pack': this.pack })
        } else {
          this.mileages = null
        }
      },
    },
  },
  beforeMount() {
    this.idArgus = this.parseOthersApiValue(this.service.others.api.value).idArgus
    this.table = this.getTable(this.service.others.api.value)

    if (this.table) {
      this.mileages = Object.keys(this.table)
      if (this.mileages.length > 0) {
        this.mileage = this.mileages[0]
        this.durations = this.getDurations(this.table)
        this.pack = Object.keys(this.table[this.mileage])[0]
        //ajout
        this.$emit('update:service', { 'others.mileage': this.mileage, 'others.pack': this.pack })
      } else {
        this.mileages = null
      }
    } else {
      this.mileages = null
    }
    this.selectMileage(this.service.others.mileage.value)
    this.selectPack(this.service.others.pack.value)
  },
}
</script>
<template>
  <div v-if="mileages != null">
    <div class="mt-3" style="text-align: center">
      <!--<button :class="'btn btn-lg ' + ((0==mileage)?'btn-primary':'btn-secondary')" style="margin-right:5px" @click="selectMileage(0)">Désactivé</button>-->
      <button
        v-for="mile in mileages"
        :class="'btn btn-lg ' + (mile == mileage ? 'btn-primary' : 'btn-secondary')"
        style="margin-right: 5px"
        @click="selectMileage(mile)"
      >
        {{ mile + ' km/an' }}
      </button>
    </div>
    <div v-if="mileage">
      <table class="table">
        <tbody>
          <tr>
            <th>{{ $t('demand.fields.finance.duration.label') }}</th>
            <th v-for="p in Object.keys(table[mileage])">
              <button :class="'btn btn-lg ' + (p == pack ? 'btn-primary' : 'btn-secondary')" @click="selectPack(p)">
                {{ p }}
              </button>
            </th>
          </tr>
          <tr v-for="duration in durations">
            <td>{{ duration }}</td>
            <td v-for="pack in Object.keys(table[mileage])" :class="pack == packBold ? 'font-weight-bold' : ''">
              {{ getPrice(pack, duration) }}
            </td>
          </tr>
        </tbody>
      </table>
      <p class="no-offer">{{ isOfferAvailable ? '&nbsp;' : $t('service.opteven.noOfferAvailable') }}</p>
    </div>
  </div>
  <div v-else>
    <div v-if="(idArgus && !table) || (table && table.length == 0)" class="alert alert-warning">
      <span>Nous n'avons pas trouvé de services correspondant au véhicule demandé</span>
    </div>
  </div>
</template>
